export default __webpack_public_path__ + "static/media/x_wdt_c_1.c7977e8d.mp3";